import { Injectable } from '@angular/core';
import {
  ConfigService,
  EntityService,
  TokenService
} from 'viggo-sistemas-core-web';
import { ITipoOperacao } from '../model/tipo_operacao.model';

@Injectable()
export class TipoOperacaoService extends EntityService<ITipoOperacao> {
  constructor(
    protected configService: ConfigService,
    protected tokenService: TokenService
  ) {
    super({
      baseEntityEndPoint: 'tipo_operacao',
      urlBackend: configService.backendURL
    });
  }
}
